/**
 * Service pour les opérations sur l'éditeur de devis
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const quoteEditorService = {
  getEditorData: (quoteId) => api.get(endpoints.quoteEditor.editorData(quoteId)),

  getLineDesignations: () => api.get(endpoints.quoteEditor.lineDesignations()),

  createLineDesignation: (data) => api.post(endpoints.quoteEditor.lineDesignations(), data),

  updateLineDesignation: (id, data) => api.put(`${endpoints.quoteEditor.lineDesignations()}/${id}`, data),

  deleteLineDesignation: (id) => api.delete(`${endpoints.quoteEditor.lineDesignations()}/${id}`)
}
